// src/app/core/constants/animations.ts
import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const OFFLINE_OVERLAY_ANIMATIONS = [
  trigger('overlayAnimation', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1 })),
    ]),
    transition(':leave', [
      animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 0 })),
    ]),
  ]),
  trigger('modalAnimation', [
    transition(':enter', [
      style({ opacity: 0, transform: 'scale(0.85) translateY(30px)' }),
      animate(
        '500ms 100ms cubic-bezier(0.34, 1.56, 0.64, 1)',
        style({ opacity: 1, transform: 'scale(1) translateY(0)' }),
      ),
    ]),
    transition(':leave', [
      animate(
        '250ms cubic-bezier(0.25, 0.8, 0.25, 1)',
        style({ opacity: 0, transform: 'scale(0.9) translateY(20px)' }),
      ),
    ]),
  ]),
  trigger('ballKick', [
    state('idle', style({ transform: 'translate(-50%, 0) scale(1)' })),
    state(
      'shooting',
      style({ transform: 'translate(-50%, 0) scale(0.4)', opacity: 0.8 }),
    ),
    transition('idle => shooting', [
      animate(
        '600ms cubic-bezier(0.2, 0, 0, 1)',
        keyframes([
          style({ transform: 'translate(-50%, 0) scale(1.15)', offset: 0.1 }),
          style({
            transform:
              'translate(var(--ball-end-x), var(--ball-end-y)) scale(0.5)',
            opacity: 0.85,
            offset: 1,
          }),
        ]),
      ),
    ]),
  ]),
  trigger('goalCelebration', [
    transition(':enter', [
      style({ opacity: 0, transform: 'scale(0.5)' }),
      animate(
        '500ms cubic-bezier(0.34, 1.56, 0.64, 1)',
        style({ opacity: 1, transform: 'scale(1)' }),
      ),
    ]),
  ]),
  trigger('pulseConnection', [
    state('checking', style({})),
    transition('* => checking', [
      animate(
        '1.5s ease-in-out',
        keyframes([
          style({ opacity: 1, offset: 0 }),
          style({ opacity: 0.4, offset: 0.5 }),
          style({ opacity: 1, offset: 1 }),
        ]),
      ),
    ]),
  ]),
] as const;

export const UPDATE_BANNER_ANIMATIONS = [
  trigger('bannerAnimation', [
    transition(':enter', [
      style({ opacity: 0, transform: 'translateY(-20px) scale(0.95)' }),
      animate(
        '420ms cubic-bezier(0.34, 1.56, 0.64, 1)',
        style({ opacity: 1, transform: 'translateY(0) scale(1)' }),
      ),
    ]),
    transition(':leave', [
      animate(
        '220ms cubic-bezier(0.4, 0, 0.2, 1)',
        style({ opacity: 0, transform: 'translateY(-12px) scale(0.97)' }),
      ),
    ]),
  ]),
] as const;

export const UPDATE_OVERLAY_ANIMATIONS = [
  trigger('overlayAnimation', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1 })),
    ]),
  ]),
  trigger('modalAnimation', [
    transition(':enter', [
      style({ opacity: 0, transform: 'scale(0.9) translateY(20px)' }),
      animate(
        '500ms 100ms cubic-bezier(0.34, 1.56, 0.64, 1)',
        style({ opacity: 1, transform: 'scale(1) translateY(0)' }),
      ),
    ]),
  ]),
] as const;
